import script from "./propagateList.vue?vue&type=script&setup=true&lang=js"
export * from "./propagateList.vue?vue&type=script&setup=true&lang=js"

import "./propagateList.vue?vue&type=style&index=0&id=46e09e52&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e09e52"]])

export default __exports__